import type { FormField, FormLogicRule } from '../types/forms'

const matchesRule = (rule: FormLogicRule, values: Record<string, unknown>) => {
  const current = values[rule.when.fieldId]
  const expected = rule.when.value
  if (rule.when.operator === 'EQUALS') return String(current ?? '') === String(expected ?? '')
  if (rule.when.operator === 'NOT_EQUALS') return String(current ?? '') !== String(expected ?? '')
  if (rule.when.operator === 'CONTAINS') return Array.isArray(current) ? current.map(String).includes(String(expected)) : String(current ?? '').includes(String(expected ?? ''))
  if (rule.when.operator === 'GREATER_THAN') return Number(current) > Number(expected)
  return Number(current) < Number(expected)
}

export type FormLogicHost = {
  fields?: FormField[]
  logic?: { rules: FormLogicRule[] } | null
}

export const LogicEngine = {
  isVisible(field: FormField, definition: FormLogicHost, values: Record<string, unknown>) {
    const rules = definition.logic?.rules?.filter((rule) => rule.then.targetFieldId === field.id && (rule.then.action === 'SHOW' || rule.then.action === 'HIDE')) ?? []
    return rules.every((rule) => rule.then.action === 'SHOW' ? matchesRule(rule, values) : !matchesRule(rule, values))
  },
  isRequired(field: FormField, definition: FormLogicHost, values: Record<string, unknown>) {
    return field.required || (definition.logic?.rules?.some((rule) => rule.then.targetFieldId === field.id && rule.then.action === 'REQUIRE' && matchesRule(rule, values)) ?? false)
  },
  visibleFields(definition: FormLogicHost, values: Record<string, unknown>) {
    return (definition.fields ?? []).filter((field) => this.isVisible(field, definition, values))
  },
  stepFor(field: FormField) { return Math.max(0, field.step ?? 0) },
}
